import React from "react";
import bg_dot_hero from '../assets/img/Illustrations/smaller_dots_bg_hero.avif';


const WhitePapersGrid = () => {

    return (
        <div className='portifoliobody'>
            <main id="main">
                <section id="whitepapers" className="about text-start" style={{paddingTop:'70px'}}>
                    <div className="blg-title">
                        <div className="blg-title-bg-img" style={{overflow:'hidden'}}><img src={bg_dot_hero} alt="" style={{ width:'inherit'}}/></div>
                        <div data-aos="fade-right" data-aos-delay="100">
                            <h1>WhitePapers</h1>
                            <p>Explore expert insights, regulatory guidance, and industry trends that drive smarter lab decisions.</p>
                        </div>
                    </div>
                    <div style={{padding:'100px 0', border:'1px solid'}}>
                        <div>
                            
                        </div>
                    </div>

                </section>
            </main>
        </div>
    )
}

export default WhitePapersGrid;